<script>
// Mixins
import flexProps from '../mixins/flex-props.js';

// Utils
import { getSlots } from '../utils/renderless-composition';
import { getFlexClasses } from '../utils/flex-class-utils';

export default {
    name: 'FlexClass',
    functional: true,
    mixins: [flexProps],
    render (createEl, context) {
        const flexClasses = getFlexClasses(context);
        return getSlots(createEl, context.children, flexClasses);   
    }
}
</script>
